<template>
  <div>
    <v-card class="pa-6">
      <div
        :class="[
          $vuetify.breakpoint.xsOnly
            ? 'd-flex flex-column'
            : 'd-flex align-center',
          listTags.length > 0 && (canCreateTag || canEditTag || canRemoveTag)
            ? 'mb-6'
            : ''
        ]"
      >
        <DialogCreateOrManage
          :isCreateType="true"
          :listTags="listTags"
          @updateListTags="getListTags"
        />
  
        <DialogCreateOrManage
          :listTags="listTags"
          @updateListTags="getListTags"
        />
  
        <v-divider
          v-if="
            !$vuetify.breakpoint.xsOnly
            && (canCreateTag || canEditTag || canRemoveTag)
          "
        ></v-divider>
      </div>

      <div v-if="fetchingListTags" class="pt-6">
        <v-progress-circular
          indeterminate
          size="16"
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-else-if="listTags.length == 0" class="pt-6">
        {{ $t("noTagsCreated") }}
      </div>
  
      <!-- <div v-if="listTags.length > 0"> -->
      <div v-else>
        <div class="d-flex align-center mb-6">
          <span class="font-weight-bold text-h6 mr-2">
            {{ $t("yourTags") }}
          </span>
  
          <DialogSeeTags
            v-if="listTags.length > 0"
            :listTags="listTags"
            @updateListTags="getListTags"
          />
        </div>
  
        <div style="display: flex; flex-wrap: wrap; gap: 8px;">
          <div
            v-for="(tag, index) in listTags.slice(0, 8)"
            :key="index"
            class="rounded-pill py-1 px-3"
            style="width: fit-content;"
            :style="{
              'background-color': tag.color + '80',
              'color': 'white',
              'border': '2px solid ' + tag.color,
            }"
          >
            {{ tag.title }}
          </div>
        </div>
      </div>
    </v-card>
    <DatatablePlayers :listTags="listTags" />
  </div>
</template>

<script>
import DialogCreateOrManage from "./DialogCreateOrManage/index.vue";
import DialogSeeTags from "./DialogSeeTags/index.vue";
import DatatablePlayers from "./DatatablePlayers/index.vue";

export default {
  name: "TagsConfig",

  components: { DialogCreateOrManage, DialogSeeTags, DatatablePlayers },

  data: () => ({
    listTags: [],
    fetchingListTags: false,
  }),

  mounted() {
    this.getListTags();
  },

  computed: {
    canCreateTag() {
      return this.$permission("141");
    },
    canEditTag() {
      return this.$permission("145");
    },
    canRemoveTag() {
      return this.$permission("142");
    },
  },

  methods: {
    getListTags() {

      this.fetchingListTags = true;
      this.$axios
        .get(`${this.$prefix()}/tags/tagsList`)
        .then((res) => {
          this.fetchingListTags = false;
          this.listTags = res.data.dados.map((tag) => ({
            ...tag,
            id: tag.tag_id,
          }));
        })
        .catch(() => {
          this.listTags = [];
          this.fetchingListTags = false;
        });
    },
  },
}
</script>